/**
 * Product card image carousel: loop + click handling
 */
document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-product-card-carousel-id][data-direction]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var carouselId = btn.getAttribute('data-product-card-carousel-id');
    var carousel = document.getElementById(carouselId);
    if (!carousel || typeof carousel.select !== 'function') return;

    var direction = btn.getAttribute('data-direction');
    var len = (carousel.cells || []).length;
    if (len === 0) return;

    var nextIndex;
    if (direction === 'prev') {
      nextIndex = carousel.selectedIndex <= 0 ? len - 1 : carousel.selectedIndex - 1;
    } else {
      nextIndex = carousel.selectedIndex >= len - 1 ? 0 : carousel.selectedIndex + 1;
    }
    carousel.select(nextIndex);
  }, true);

  var quickAddStart = null;

  document.body.addEventListener('pointerdown', function (e) {
    var btn = e.target.closest('.product-card__quick-add-button');
    quickAddStart = btn ? { x: e.clientX, y: e.clientY, btn: btn } : null;
  }, true);

  document.body.addEventListener('pointerup', function (e) {
    if (!quickAddStart) return;

    var btn = quickAddStart.btn;
    var moved = Math.abs(e.clientX - quickAddStart.x) > 10 || Math.abs(e.clientY - quickAddStart.y) > 10;
    quickAddStart = null;
    if (moved || (e.target !== btn && !btn.contains(e.target))) return;

    e.preventDefault();
    e.stopPropagation();
    btn.dataset.quickAddHandled = 'true';

    var modal = document.getElementById(btn.getAttribute('aria-controls'));
    if (modal && typeof modal.show === 'function') {
      modal.show();
      return;
    }

    var form = btn.form || btn.closest('form');
    if (!form) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(btn);
    else form.submit();
  }, true);

  document.body.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-card__quick-add-button');
    if (!btn || btn.dataset.quickAddHandled !== 'true') return;
    delete btn.dataset.quickAddHandled;
    e.preventDefault();
    e.stopPropagation();
  }, true);
});
